// Shared formatting helpers. Every JS-per-page file used to reimplement these;
// now they live in one place so date logic drifts in one file, not five.

export function timeAgo(iso: string): string {
    const d = new Date(iso);
    const s = Math.floor((Date.now() - d.getTime()) / 1000);
    if (s < 60)     return 'just now';
    if (s < 3600)   return Math.floor(s / 60)    + 'm';
    if (s < 86400)  return Math.floor(s / 3600)  + 'h';
    if (s < 604800) return Math.floor(s / 86400) + 'd';
    return d.toLocaleDateString('en-ZA', { day: 'numeric', month: 'short' });
}

/** "Sat 15 Aug · 18:30–20:00" or "Sat 15 Aug · 18:30 → Sun 16 Aug · 10:00". */
export function formatEventRange(startsIso?: string | null, endsIso?: string | null): string {
    if (!startsIso) return '';
    const s = new Date(startsIso);
    if (isNaN(s.getTime())) return '';
    const day = s.toLocaleDateString('en-ZA', { weekday: 'short', day: 'numeric', month: 'short' });
    const hh  = s.toLocaleTimeString('en-ZA', { hour: '2-digit', minute: '2-digit' });
    if (!endsIso) return `${day} · ${hh}`;
    const e = new Date(endsIso);
    if (isNaN(e.getTime())) return `${day} · ${hh}`;
    if (e.toDateString() === s.toDateString()) {
        return `${day} · ${hh}–${e.toLocaleTimeString('en-ZA', { hour: '2-digit', minute: '2-digit' })}`;
    }
    return `${day} · ${hh} → ${e.toLocaleDateString('en-ZA', { weekday: 'short', day: 'numeric', month: 'short' })} · ${e.toLocaleTimeString('en-ZA', { hour: '2-digit', minute: '2-digit' })}`;
}

/** "3h left" / "expired" — for offers with valid_until. */
export function offerValidity(untilIso?: string | null): string {
    if (!untilIso) return '';
    const t = new Date(untilIso);
    const diff = t.getTime() - Date.now();
    if (diff <= 0) return 'expired';
    const h = Math.floor(diff / 3_600_000);
    if (h < 24) return `${h}h left`;
    return `${Math.floor(h / 24)}d left`;
}

/** Compact date for a masthead: "Tuesday, 12 August 2026". */
export function formatMastheadDate(d: Date = new Date()): string {
    return d.toLocaleDateString('en-ZA', {
        weekday: 'long', day: 'numeric', month: 'long', year: 'numeric',
    });
}
